module.exports = __webpack_public_path__ + "img/gPay-Share.0b6971ee.svg";